/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GonzaloApiResponseDto } from './gonzaloApiResponseDto';
import { PositionV2Dto } from './positionV2Dto';
import { GonzaloApiRequestObject } from './gonzaloApiRequestObject';

export interface TrackplanningSVGDto {
  fieldId?: number;
  lowerRight?: PositionV2Dto;
  request?: GonzaloApiRequestObject;
  response?: GonzaloApiResponseDto;
  stats?: { [key: string]: number };
  svgString?: string;
  upperLeft?: PositionV2Dto;
}
